import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DeleteSalesDialog(props) {
  const { client_id, trip_id, sales_id, showDialog, hideDialog, deleteSales } =
    props;
  const [open, setOpen] = useState(true);

  const handleDelete = (e) => {
    deleteSales(e);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    hideDialog(false);
  };

  return (
    <div>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open || showDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Delete Sales`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please confirm delete Sales on this device. This action cannot be
            undone!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(e) => handleDelete(e)}
            autoFocus
            data-client_id={client_id}
            data-trip_id={trip_id}
            data-sales_id={sales_id ? sales_id : 0}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteSalesDialog;
